<template>
  <div class="analytics user-analytics">
    <filter-bar
      :timeframe="timeframe"
      @change="setTimeframe"
    />

    <stats
      :data="basicMetrics"
      :props="basicMetricProps"
      :min-width="minWidth">

  </stats>

    <line-chart
      v-if="dimensions"
      :items="readership"
      :width="dimensions.width"
      :client-width="clientWidth"
      :min-width="minWidth"
      :height="500"
      :timeframe-labels="timeframeLabels"
      class="mt-3"
    />


    <!-- <multiple-ranking-lists
      :settings="topListTypes"
      :ranking-lists="topLists"
      :client-width="clientWidth"
      :data="data"
    /> -->
          <ranking-list
      title="Top Articles"
        :items="(cogData ? cogData.topArticles : []).map((tr) => ({
          id: tr.articleId,
          name: tr.article ? tr.article.title : '-',
          value: tr.views,
          lastValue: 0,
          diffNum: false,
          diffStr: '',
          webDownloads: tr.downloads || 0,
          emailViews: 0,
          sendgridOpened: 0,
          valueRank: 1,
          lastValueRank: -1,
          change: 0,
          engagement: 4,
          position: 1,
          account: '',
          account_id: 0,
          channel: tr.article ? tr.article.channel : '-',
          channel_id: tr.article ? tr.article.channelId : '-',
          analyst: tr.article ? tr.article.primaryAnalyst || '-' : '-',
          analyst_id: tr.article ? tr.article.analystIds[0] : '-',
          companies: null,
          email: '',
        }))"
        :active-id="data.id"
        :settings="{
          title: 'Top Articles',
          path: 'articles',
          colWidth: 12,
          activeEnabled: true,
          cols: ['name', 'channel', 'analyst', 'webDownloads', 'engagement'],
          type: 'infinity-rank',
        }"
        :client-width="clientWidth"
      />
  </div>
</template>

<script>
import RankingList from '@/components/RankingList'
import {constructReadership} from '@/analytics/data-analyser'

import AnalyticsMixin from '@/analytics/mixins/AnalyticsMixin'
import TimeframeMixin from '@/analytics/mixins/TimeframeMixin'

import FilterBar from '@/components/FilterBar'
import Stats from '@/components/Stats'
import LineChart from '@/components/d3/LineChart'

export default {
  components: {
    FilterBar,
    Stats,
    LineChart,
    RankingList,
  },
  mixins: [AnalyticsMixin, TimeframeMixin],
  props: {
    channelName: {
      type: String,
      default: 'Network',
    },
  },
  async mounted() {
    const response = await this.loadData(
      `users/${this.data.id}`,
      undefined,
      this.$login.channelScopeId()
    )

    // console.log(response)
    // this.basicMetrics = {
    //   current: {
    //     webViews: response.data.webViews,
    //     emailDelivers: response.data.emailDelivers,
    //     emailClicks: response.data.emailClicks,
    //     emailOpens: response.data.emailOpens,
    //   },
    // }
    // console.log(this.basicMetrics, this.basicMetricProps)

    this.topLists = {
      articleUser: response.data.topArticles.map((tr,i) => ({
        id: tr.article.id,
        name: tr.article.title,
        value: tr.views,
        lastValue: 0,
        diffNum: false,
        diffStr: '',
        webDownloads: tr.downloads || 0,
        emailViews: 0,
        sendgridOpened: 0,
        valueRank: i+1,
        lastValueRank: -1,
        change: 0,
        engagement: 4,
        position: 1,
        account: '',
        account_id: '',
        channel: '-',
        channel_id: '-',
        analyst: '-',
        analyst_id: null,
        companies: null,
        email: '',
      })),
    }
  },
  data () {
    return {
      lineChartSources: ['webViews'],
      analyticsType: 'user',
      basicMetricProps: [ 'webViews', 'emailClicks', 'userStat'],
      basicTopListTypes: {
        userTopic: {title: 'Key Interests', path: false, colWidth: 4, activeEnabled: false, cols: null, type: 'infinity-rank'},
        accountUser: {title: this.accountName, path: 'users', colWidth: 4, activeEnabled: true, cols: null},
        networkUser: {title: `${this.channelName} League Table`, path: 'users', colWidth: 4, activeEnabled: true, cols: null},
        userArticle: {title: 'Top Articles', path: 'articles', colWidth: 12, activeEnabled: true, cols: ['name', 'channel', 'analyst', 'webDownloads', 'engagement'], type: 'infinity-rank'},
      },

    }
  },
  computed: {
    topListTypes () {
      const results = {...this.basicTopListTypes}
      for (const type in results) {
        if (type === 'accountUser') {
          if (this.data.account_id === null) {
            delete results[type]
          } else {
            results[type].title = this.accountName
          }
        }
      }

      return results
    },
    accountName () {
      return `${this.data.account ? this.data.account.name : 'Account'} League Table`
    },
    timeframeLabels() {
      if (!this.cogData ) {
        return []
      }

      const labels = this.cogData.series[this.timeframe].webViewsDaily.map((item) => item.date)
      return labels
    },
  },
  watch: {
      timeframe: function (timeframe, oldData) {
      // this.loadData(timeframe)
      if (this.cogData) {
        // this.treemapItems = this.cogData.engagement[
        //   this.timeframe
        // ].accounts.map((ae) => ({
        //   id: ae.id.toString(),
        //   name: ae.name,
        //   value: ae.value,
        //   lastValue: ae.lastValue,
        //   diffNum: ae.difference,
        //   diffStr: ae.differenceText,
        //   valueRank: ae.rank,
        //   lastValueRank: ae.prevRank,
        //   change: ae.rankChange,
        //   position: ae.rank,
        // }))
        this.readership = {webViews: this.cogData.series[this.timeframe].webViewsDaily.map((x) => x.value)};
        this.basicMetrics = this.cogData.basicMetrics[this.timeframe].totals
        const userStat = {gdpr: this.data.is_gdpr_compliant, reader: this.basicMetrics.current.webViews}
        this.$set(this.basicMetrics.current, 'userStat', userStat )
      }
    },

    cogData() {
        // this.treemapItems = this.cogData.engagement[
        //   this.timeframe
        // ].accounts.map((ae) => ({
        //   id: ae.id.toString(),
        //   name: ae.name,
        //   value: ae.value,
        //   lastValue: ae.lastValue,
        //   diffNum: ae.difference,
        //   diffStr: ae.differenceText,
        //   valueRank: ae.rank,
        //   lastValueRank: ae.prevRank,
        //   change: ae.rankChange,
        //   position: ae.rank,
        // }))

        this.basicMetrics = this.cogData.basicMetrics[this.timeframe].totals
        this.readership = {webViews: this.cogData.series[this.timeframe].webViewsDaily.map((x) => x.value)};
        const userStat = {gdpr: this.data.is_gdpr_compliant, reader: this.basicMetrics.current.webViews}
        this.$set(this.basicMetrics.current, 'userStat', userStat )

    },
    keenAnalyses: function (newData) {
      if (newData !== null) {
        // this.basicMetricProps.push('avgReadTime')
        // this.constructBasicMetrics()
        // console.log('BASIC',this.basicMetrics)

        // this.basicMetricProps.pop()

        // this.readership = constructReadership(newData, this.lineChartSources, this.analyticsType)
        // console.log('rs',this.readership)

        // this.constructTopList('network', 'user', 'custom_attributes.user_id', 0, this.sources, 'rank', this.data.id, 10, this.basicMetrics)

        // if (this.data.account_id !== null) {
        //   this.constructTopList('account', 'user', 'custom_attributes.user_id', this.data.account_id, this.sources, 'rank', this.data.id, 10, this.basicMetrics)
        // }

        // this.constructKeyTopics()
      }
    },
  },
}
</script>
